import IdentificationError from './IdentificationError';
class INEFileIsEmpty extends IdentificationError {
    constructor(section, options) {
        super(`INE ${section} file not has information`, options);
    }
}
export default INEFileIsEmpty;
